import React, {useEffect, useState} from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import GeoMap from "./geo-map/GeoMap"
import Sidebar from "./sidebars/Sidebars"

import "leaflet-draw/dist/leaflet.draw-src.css"
import Svgs from "./Svgs";
import {initAppDispatchAction} from "../state/application/dispatchActions";
import {ConfigurationsType} from "../types/configurations";
import Loader from "./shared/Loader";
import {isSatelliteImagery} from "../helpers/configurationHelper";
import {AppParametersType} from "../types/app";

interface IProps {
  applicationError: boolean,
  appParameters: AppParametersType,
  configurations: ConfigurationsType,
  sidebarFirstPartShown: boolean,
  sidebarSecondPartShown: boolean,
  sidebarProcessingParametersShown: boolean,
  isSearchResultDetailsShown: boolean,
  initAppActionHandler(win: Window): void
}

const App = (props: IProps) => {
  const {
    applicationError,
    appParameters,
    configurations,
    sidebarFirstPartShown,
    sidebarSecondPartShown,
    sidebarProcessingParametersShown,
    isSearchResultDetailsShown,
    initAppActionHandler
  } = props;

  useEffect(() => {
    // initAppActionHandler(window)
    // pulisco ogni sessione precedente
    sessionStorage.removeItem("jwtAuth");
    sessionStorage.removeItem("refresh");
    window.addEventListener("message", (event) => {
      if (event.data.access_token && event.data.refresh_token) {
        const currentToken = sessionStorage.getItem("jwtAuth");
        if (event.data.access_token) {
          sessionStorage.setItem("jwtAuth", event.data.access_token);
        }
        if (event.data.refresh_token) {
          sessionStorage.setItem("refresh", event.data.refresh_token);
        }
        if (event.data.id_token) {
          sessionStorage.setItem("id", event.data.id_token);
        }
        if (!currentToken) {
          initAppActionHandler(window); // avvio l'applicazione
          console.log("Token received from CMS", event.data);
        } else {
          console.log("New token received from CMS", event.data);
        }
      }
    });
    window.parent.postMessage({ready: true}, "*");
    return () => {};
    // eslint-disable-next-line
  }, []);

  let sidebarBackground;
  let sidebarWidth = 0;
  if (appParameters && !isSatelliteImagery(configurations, appParameters)) { // custom flow sidebar
    sidebarWidth = -1;
    sidebarBackground = "#EEF1F6";
  } else { // standard flow sidebars
    if (sidebarFirstPartShown) {
      sidebarWidth += 550; // $first-part-sidebar-width in scss
    }
    if (sidebarSecondPartShown) {
      sidebarWidth += 768; // $second-part-sidebar-width in scss
    }
    if (sidebarProcessingParametersShown) {
      sidebarWidth += 550; // $processing-params-sidebar-width in scss
    }
    if (isSearchResultDetailsShown) {
      sidebarWidth += 550; // $search-result-details-sidebar-width in scss
    }
  }

  const actualSidebarWidth = sidebarWidth >= 0 ? sidebarWidth : "100%";
  let actualGeoMapWidth = "0";
  if (sidebarWidth >= 0) {
    actualGeoMapWidth = sidebarWidth === 0 ? "100%" : `calc(100% - ${sidebarWidth}px)`;
  }

  let appHtml = <></> // <Loader containerClassName="full-page dark-background" spinnerClassName="big white-mode" />
  if (applicationError) {
    appHtml = (
      <div className="application-error-container full-page dark-background">{applicationError}</div>
    )
  } else if (configurations) {
    appHtml = (
      <div className="map-container">
        <GeoMap width={actualGeoMapWidth} />
        <Sidebar background={sidebarBackground || undefined} width={actualSidebarWidth} />
      </div>
    )
  }

  return (
    <div className="MapApp">
      <Svgs />
      {appHtml}
    </div>
  )
}

const mapStateToProps = (state) => ({
  applicationError: state.application.error,
  appParameters: state.application.appParameters,
  configurations: state.application.configurations,
  sidebarFirstPartShown: state.application.sidebarFirstPartShown,
  sidebarSecondPartShown: state.application.sidebarSecondPartShown,
  sidebarProcessingParametersShown: state.application.sidebarProcessingParametersShown,
  isSearchResultDetailsShown: state.application.isSearchResultDetailsShown,
})

const mapDispatchToProps = (dispatch) => ({
  initAppActionHandler: (win) => dispatch(initAppDispatchAction(win))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App))
